import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const FloatingNavigation = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [activeSection, setActiveSection] = useState('hero');
  const [userType, setUserType] = useState('individual');
  const location = useLocation();

  const individualNavItems = [
    { id: 'hero', label: 'Home', icon: 'Home' },
    { id: 'community', label: 'Community', icon: 'Users' },
    { id: 'projects', label: 'Projects', icon: 'Code' },
    { id: 'success', label: 'Success Stories', icon: 'Trophy' },
    { id: 'join', label: 'Join Now', icon: 'Rocket' }
  ];

  const institutionalNavItems = [
    { id: 'hero', label: 'Home', icon: 'Home' },
    { id: 'solutions', label: 'Solutions', icon: 'Building2' },
    { id: 'roi', label: 'ROI', icon: 'TrendingUp' },
    { id: 'case-studies', label: 'Case Studies', icon: 'FileText' },
    { id: 'demo', label: 'Book Demo', icon: 'Calendar' }
  ];

  const quickActions = [
    { 
      id: 'learning', 
      label: 'Start Learning', 
      icon: 'Play', 
      path: '/individual-learning-new',
      color: 'text-accent'
    },
    // { 
    //   id: 'solutions', 
    //   label: 'Enterprise', 
    //   icon: 'Building2', 
    //   path: '/institutional-solutions-hub',
    //   color: 'text-cyber-purple'
    // },
    { 
      id: 'community', 
      label: 'Community', 
      icon: 'Users', 
      path: '/about-dream-coders-club',
      color: 'text-success'
    },
    { 
      id: 'support', 
      label: 'Support', 
      icon: 'MessageCircle', 
      path: '/contact-support',
      color: 'text-warning'
    }
  ];

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      setIsVisible(scrollY > 100);

      // Determine active section based on scroll position
      const sections = ['hero', 'community', 'projects', 'success', 'join'];
      const currentSection = sections.find(section => {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          return rect.top <= 100 && rect.bottom >= 100;
        }
        return false;
      });

      if (currentSection) {
        setActiveSection(currentSection);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const toggleUserType = () => {
    setUserType(prev => prev === 'individual' ? 'institutional' : 'individual');
  };

  const currentNavItems = userType === 'individual' ? individualNavItems : institutionalNavItems;

  return (
    <>
      {/* Main Floating Navigation */}
      {/* <div
        className={`fixed left-1/2 transform -translate-x-1/2 bottom-6 z-50 transition-all duration-500 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
        }`}
      >
        <div className="bg-card/95 backdrop-blur-md border border-border rounded-2xl shadow-elevated p-2">
          <div className="flex items-center space-x-1">
            {currentNavItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className={`relative px-4 py-2 rounded-xl text-sm font-medium transition-all duration-300 group ${
                  activeSection === item.id
                    ? 'text-accent bg-accent/10 shadow-glow'
                    : 'text-muted-foreground hover:text-foreground hover:bg-muted/50'
                }`}
                title={item.label}
              >
                <div className="flex items-center space-x-2">
                  <Icon name={item.icon} size={16} />
                  <span className="hidden sm:inline">{item.label}</span>
                </div>
                
                {activeSection === item.id && (
                  <div className="absolute inset-0 bg-gradient-to-r from-accent/20 to-cyber-purple/20 rounded-xl"></div>
                )}
              </button>
            ))}
          </div>
        </div>
      </div> */}

      {/* User Type Toggle */}
      {/* <div
        className={`fixed right-6 bottom-6 z-50 transition-all duration-500 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
        }`}
      >
        <button
          onClick={toggleUserType}
          className="bg-card/95 backdrop-blur-md border border-border rounded-xl shadow-elevated p-3 hover:shadow-glow transition-all duration-300 group"
          title={`Switch to ${userType === 'individual' ? 'Institutional' : 'Individual'} view`}
        >
          <div className="flex items-center space-x-2">
            <Icon 
              name={userType === 'individual' ? 'Building2' : 'User'} 
              size={18} 
              className="text-muted-foreground group-hover:text-foreground transition-colors duration-300"
            />
            <span className="text-xs text-muted-foreground group-hover:text-foreground transition-colors duration-300 hidden sm:inline">
              {userType === 'individual' ? 'Enterprise' : 'Individual'}
            </span>
          </div>
        </button>
      </div> */}

      {/* Quick Actions Menu */}
      <div
        className={`fixed left-6 bottom-6 z-50 transition-all duration-500 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
        }`}
      >
        <div className="flex flex-col space-y-2">
          {quickActions.map((action) => (
            <Link
              key={action.id}
              to={action.path}
              className="bg-card/95 backdrop-blur-md border border-border rounded-xl shadow-elevated p-3 hover:shadow-glow transition-all duration-300 group"
              title={action.label}
            >
              <Icon 
                name={action.icon} 
                size={18} 
                className={`${action.color} group-hover:scale-110 transition-transform duration-300`}
              />
            </Link>
          ))}
        </div>
      </div>

      {/* Progress Indicator */}
      <div
        className={`fixed top-0 left-0 right-0 z-50 h-1 bg-muted/30 transition-opacity duration-500 ${
          isVisible ? 'opacity-100' : 'opacity-0'
        }`}
      >
        <div
          className="h-full bg-gradient-to-r from-accent to-cyber-purple transition-all duration-300"
          style={{
            width: `${Math.min((window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100, 100)}%`
          }}
        />
      </div>
    </>
  );
};

export default FloatingNavigation;